export const CustomerLossHistoryScreenLables = {
    general: "GENERAL",
    company: "Company",
    employeeName: "Employee Name",
    description: "Description",
    lossDetail: "LOSS DETAIL",
    policyNumber: "Policy Number",
    claimNumber: "Claim Number",
    kindOfLoss: "Kind of Loss",
    dateOfLoss: "Date of Loss",
    effectiveDate: "Effective Date",
    dateReported: "Date Reported",
    expirationDate: "Expiration Date",
    amountToPay: "Amount To be Paid",
    claimStatus: "Claim Status",
    closeDate: "Close Date",
    LOSS_HISOTRY: "LOSS HISTORY",
};

export const TaskScreenLables = {
    taskDescription: 'Description',
    CREATE_TASK: 'Create Task',
    dueDate: 'Due Date',
    taskType: 'Action',
    priority: 'Priority',
    status: 'Status',
    completionDate: 'Completion Date',
    cc: 'CC / Notify',
    createdBy: 'Created By',
    assignedTo: 'Assigned To',
    customerName: 'Customer Name',
    policyNumber: 'Policy Number',
    claimNumber: 'Claim Number',
    company: 'Company',
    tasks: 'Tasks',
    rowexpander: 'Row Expander',
    pleaseSelect: "Please Select",
    newTask: "New Task",
    description: "Description",
    dateTime: "Date Time",
    field: "Field",
    oldValue: "Old Value",
    newValue: "New Value",
    user: "User"
}


export const CustomerPolicyListScreenLables = {
    PROPERTY_ADDRESS: "Property Address",
    STATUS: "Status",
    AGENCY_NOTATION: "Agency Notation",
    APLUS_REFERENFCE: "A+ Reference",
    INSURANCE_COMPANY: "Insurance Company",
    FORM_TYPE: "Form Type",
    LINE_OF_BUSINESS: "Line of Business",
    POLICY_NUMBER: "Policy Number",
    POLICY_TYPE: "CS2 Policy Type",
    POLICY_TYPE_LOB: "Policy Type LOB",
    PREMIUM: "Premium",
    TERM: "Term",
    LAT_LONG: "LAT LONG",
    SOURCE: "Source",
    PRODUCER: "Producer",
    DESCRIPTION: "Description"
}

export const CustomerScreentLables =
{
    FIRST_NAME: "First Name",
    MIDDLE_NAME: "Middle Name",
    LAST_NAME: "Last Name",
    DISPLAY_NAME: "Display Name",
    FIRM_NAME: "Firm Name",
    ENTITY_TYPE: "Entity Type",
    NO_OF_MEMBERS: "Number of Members and Managers",
    WEBSITE: "Website",
    FAX: "Fax",
    HOME: "Home",
    VIP: "VIP",
    BUILDER_LEASE_BACK: "Builder LeaseBack",
    MULTI_POLICY: "Multi-Policy",
    INDUSTRY: "Industry",
    OCCUPATION: "Occupation",
    YEAR_EMPLOYED: "Year Employed",
    GENDER: "Gender",
    AGENCY: "Agency",
    AGENCY_GROUP: "Select Agency Group",
    MARITAL_STATUS: "Marital Status",
    COUNTRY: "Country",
    COUNTRY_CODE: "Country Code",
    SUPERVISOR: "Employee Supervisor",
    UPDATED_DATE: "Updated Date",
    STREET: "Street",
    APARTMENT_OR_UNIT: "Apt / Unit",
    CITY: "City",
    STATE: "State",
    ZIP: "Zip",
    ZIP_CODE: "Zip Code",
    TAX_CODE: "Tax Code",
    YEARATADDRESS: "Years at Address",
    SAME_AS_MAILING: "Set Billing the same as Mailing",
    INSURED_SAME_AS_BILLING:"Same as Mailing",
    RELATIONSHIP: "Relationship",
    DO_NOT_MAIL: "Do Not Mail",
    DO_NOT_EMAIL: "Do Not Email",
    SMS_OPT_OUT: "SMS Opt-Out",
    DO_NOT_CALL: "Do Not Call",
    EDD_OPT_IN: "EDD Opt-In",
    CELL_PHONE: "Cell Phone",
    HOME_PHONE: "Home",
    WORK_PHONE: "Work",
    MOBILE: "Mobile",
    OTHER_PHONE1: "Other Phone 1",
    OTHER_PHONE2: "Other Phone 2",
    OTHER_PHONE3: "Other Phone 3",
    EMAIL_1: "Email 1",
    EMAIL_2: "Email 2",
    EMAIL_3: "Email 3",
    EMAIL_4: "Email 4",
    EMAIL_5: "Email 5",
    FULLTIME_INDICATOR: "FullTime Indicator",
    UPDATED_BY: "FullTime Indicator",
    PHONE: "Phone",
    ENTERED_DATE: "Entered Date",
    INDIVIDUALIZED : "Individualized",
    DECLARATIONNAME: "Declaration Name",
    PHONE_MASK: "999-999-9999",

    // Panel Lables
    CUSTOMER_INFORMATION: "Customer Information",
    ADDITIONAL_CUSTOMER_INFORMATION: "Additional Customer Information",
    CONTACT_INFORMATION: "Contact Information",
    MAILING_ADDRESS: "Mailing Address",
    BILLING_ADDRESS: "Billing Adress",

    ADD_ADDITIONAL_CUSTOMER_BUTTON: "+ ADD ADDITIONAL CUSTOMER",

    ADD_COMPANY_CONTACT: "+ ADD COMPANY CONTACT",

    // Customer Company lable
    NAME: "Name",
    TITLE: "Title",
    FORMAL_SALUTATION: "Formal Salutation",
    PHONE_NUMBER: "Phone Numbers",
    EXT: "Ext",
    EMAIL: "Email",
    ADDRESS_1: "Address Line 1",
    ADDRESS_2: "Address Line 2",
    WEB_ADDRESS: "Web Address",
    COUNTY: "County",
    LEGACY_NOTATION_CODE: "Notation Code",
};

export const CustomerMemosLabel =
{
    CUSTOMER_MEMO: "Customer Memo",
    MEMO_DATE: "Memo Date",
    DESCRIPTION: "Description",
    ADD_NEW_MEMO: "Add Memo",
    NEW_MEMO: "New Memo",
}

export const CustomerMailMergeLabel =
{
    MAIL_MERGE: "Mail Merge",
}

export const CustomerSendDocViaEmailLabel =
{
    SEND_DOC: "Email Documents",
    SUBJECT_LINE: "Subject Line",
    RECEPIENT:"Enter email(s) separated by semicolon(;)",
    EMAIL_BODY: "Email Body"
}

export const StandardSearchLable =
{
    SEARCH_INSURED: "Search Insured",
    SEARCH_CO_INSURED: "Search CoInsured",
    ACCOUNT: "CS2 Account Number",
    POLICY_NUMBER: "Policy Number",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    PHONE: "Phone",
    CELL: "Cell",
    HOME: "Home",
    WORK: "Work",
    SEARCH_PROPERTY: "Search Property",
    SEARCH_MAILING: "Search Mailing",
    STREET_ADDRESS: "Address Line 1",
    APRARTMENT: "Address Line 2",
    CITY: "City",
    STATE: "State",
    ZIP: "Zip",
    CLEAR: "Clear",
    RESET:"Reset",
    SEARCH: "Search",
    NAME: "Name",
    ADDRESS: "Address",
    AGENCY: "Agency",
    COUNTRY: "Country",
    SEARCH_CUSTOMER: "Customer Info",
}

export const CustomerActivityLabel = {
    NEW_ACTIVITY: 'New Activity',
    CUSTOMER_ACTIVITY: "Customer Activities",
    ADD_CUSTOMER_ACTIVITY: "Add Activity",
    ACTION_TYPE: "Action Type",
    TIME: "Time",
    TRANSACTION: "Transaction",
    DESCRIPTION: "Description",
    POLICY_NUMBER: "Policy Number",
    EFFECTIVE_DATE: "Effective Date",
    CSR: "CS2 User",
    ACTIVITY_TYPE: "Action",
    CUSTOMER_SELECT: "Customer",
    POLICY_SELECT: "Policy Number",
    CLAIM_SELECT: "Claim Number",
    ACTIVITY_EFFECTIVE_DATE: 'Effective Date',
    CUSTOMER_POLICY_INFORMATION: 'Customer Policy Information',
    PLEASE_SELECT: "Please Select"
}

export const CustomerHistoryLabel = {
    FIELD: "Field",
    OLD_VALUE: "Old Value",
    NEW_VALUE: "New Value",
    USER: "User",
    TIMESTAMP: "Timestamp",
    ACTION: "Action",
    ENTITY: "Entity",
    REASON: "Reason",
    EMPLOYEE_EMAIL: "Employee Email",
    AGENCY_GROUP: "Agency Group",
    AGENCY: "Agency",
    SUPERVISOR: "Supervisor",
    TITLE: "Title",
    EMPLOYMENT_TYPE: "Employment Type",
    ACTIVE_STATUS: "Active Status",
    EMPLOYEE_CREATED_DATE: "Employee Created Date",
    EMPLOYEE_LAST_MODIFIED_DATE: "Employee Last Modified Date",
    ROLE: "Role"
}

export const RolePrivilegeSetupLabels = {
    ROLE: "Role",
    NEW_ROLE: "NEW ROLE",
    ROLE_NAME: "Role Name",
    ADD_SCREEN_PRIVILEGE: "ADD SCREEN PRIVILEGE GROUP",
    PRIVILEGE: "PRIVILEGE",
    VIEW: "VIEW",
    CREATE: "CREATE",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
    READ: "READ",
    HISTORY_FROM_DATE: "From Date",
    HISTORY_TO_DATE: "To Date",
    GET_RESULTS: "GET RESULTS",
    RESET: "RESET"
}

export const AgencySetupLabels = {
    NEW_GROUP: "NEW GROUP",
    DELETE_GROUP: "DELETE GROUP",
    ADD_SCREEN_AGENCY: "ADD NEW AGENCY",
    DESCRIPTION: "GROUP NAME",
    AGENCY: "AGENCY",
    PLEASE_SELECT: "Please Select"
}


export const CustomerPolicyDetailLabels = {
    BASIC: 'Basic',
    ENDORSEMENTS: 'Endorsements',
    ENDORSEMENT: 'Endorsement',
    UNDERWRITING: 'Underwriting',
    TRANSACTIONS: 'Transactions',
    LOB: 'Lines of Business',
    BASIC_COVERAGE: "Basic Coverage",
    ADDITIONAL_INTERESTS : "Additional Interests",
    ADD_ADDITIONAL_INTEREST : "Add Additional Interest",
    Limit_1: "Limit 1 ($)",
    Limit_2: "Limit 2 ($)",
    EARTHQUAKE: "Earthquake (%)",
    DED_TYPE_AMT1: "All Peril/Amt-1 ($)",
    DED_TYPE_AMT2: "Wind/Hail/Amt-2 ($)",
    DED_TYPE_AMT3: "Theft/Amt-3 ($)",
    All_Peril_Ded: "All Peril Ded ($)",
    Wind_Hail_Ded: "Wind/Hail Ded ($)",
    Theft_Ded: "Theft Ded ($)",
    Premium: "Premium ($)",
    DED_TYPE_AMT: "Ded Type/Amt ($)",
    MARKET_VALUE: 'Market Value',
    YEAR_BUILT: 'Year Built',
    OCCUPANCY: 'Occupancy',
    RESIDENCETYPE_USAGE: 'Residence Type/Usage',
    TOTAL_SQ_FT: 'Total Sq. Ft',
    HOUSEKEEPING: 'Housekeeping',
    PURCHASE_PRICE: 'Purchase Price',
    PURCHASE_DATE: 'Purchase Date',
    CONSTRUCTION_TYPE: 'Construction Type',
    ROOF_MATERIAL: 'Roof Material',
    FOUNDATION: 'Foundation',
    SPRINKLER: 'Sprinkler',
    DWELLING_COVERAGE: 'Dwelling Coverage',
    Date_Inspected: 'Date Inspected',
    PROTECTION_CLASS: 'Protection Class',
    Wind_Class: 'Wind Class',
    Storm_Shutters: 'Storm Shutters',
    Structure: 'Structure',
    Heat_Type: 'Heat Type',
    No_of_Bathrooms: '# of Bathrooms',
    NO_OF_ROOMS: '# of Rooms',
    Condition: 'Condition',
    Basement: 'Basement',
    Dwelling_Loc: 'Dwelling Loc',
    Secondary_Heat: 'Secondary Heat',
    No_of_Stories: '# of Stories',
    Years_Occupied: 'Years Occupied',
    Oil_Storage: 'Oil Storage',
    Swimming_Pool: 'Swimming Pool',
    Pet: 'Pet',
    UNDERWRITING_RATING : 'RATING/UNDERWRITING',
    UNDERWRITING_INFORMATION: 'Underwriting Information',
    RATING_INFORMATION: 'Rating Information',
    SQUARE_FOOTAGE: 'Square Footage',
    GROUND_FLOOR_AREA: 'Ground Floor Area',
    NUMBER_OF_STORIES: 'Number Of Stories',
    NUMBER_OF_APTS: '# of Apts',
    NUMBER_OF_FAMILIES: '# Families',
    NUMBER_IN_HOUSEHOLD: '# in Household',
    WEEKS_RENTED: '# Weeks Rented',
    DWELLING_USE: 'Dwelling Use',
    TERRITORY_CODE: 'Territory Code',
    TAX_CODE: 'Tax Code',
    PLACE_CODE: 'Place Code',
    BUILDING_CODE: 'Building Code',
    FIRE_DISTRICT: 'Fire District',
    DISTRICT_CODE: 'District Code',
    MILES_TO_FIRE_STATION: 'Miles to Fire Station',
    FEET_TO_HYDRANT: 'Feet to Hydrant',
    UNITS_FIRE_DIV: '# Units Fire Div',
    FIRE_DIVISIONS: '# Fire Divisions',
    EC_PREM_GROUP: 'EC Prem Group',
    FIRE_EC_RATE: 'Fire/EC Rate',
    STATE_REQUIREMENTS: 'State Requirements',
    EXTERIOR_PAINT: 'Exterior Paint',
    TRANSACTION_EFFECTIVE_DATE: 'Transaction Effective Date',
    TRANSACTION_DESCRIPTION: 'Transaction Description',
    TRANSACTION_TYPE: 'Transaction Type',
    SEQNUM:'Seqnum',
    LOCATION_NUMBER : 'Location #',
    UPDATE_FORM_MAIL_ADDRESS: 'Update from Mail Address',
    ATTACH_TYPE: 'Attach Type',
    ATTACH_VALUE: 'Attach Value',
    INTEREST_TYPE: 'Interest Type',
    ADDITIONAL_INTEREST_NAME: 'Additional Interest Name',
    NAME: 'Name',
    NAME1: 'Name',
    NAME2: 'Name 2',
    ADDRESS : 'Address',
    ADDRESS1: 'Address 1',
    ADDRESS2: 'Address 2',
    CITY: 'City',
    STATE : 'State',
    ZIP_CODE : 'Zip Code',
    LOAN_NUMBER : 'Loan Number', 
    PAYOR: 'Payor',
    BUSINESS_PHONE: 'Business Phone',
    FAX: 'Fax',
    EMAIL_1: 'Email 1',
    EMAIL_2: 'Email 2',
    RANK: 'Rank',
    INSURED_NAME: 'INSURED NAME',
    CO_INSURED: 'CO-INSURED',
    BASIC_POLICY_INFORMATION: 'BASIC POLICY INFORMATION',
    BASIC_VEHICLE_INFORMATION: 'BASIC VEHICLE INFORMATION',
    STATUS : 'Status',
    POLICY_NUMBER: "Policy Number",
    EFFECTIVE_DATE: "Effective Date",
    EXPIRATION_DATE: "Expiration Date",
    CONTINOUS : "Continuous",
    FREQUENCY : "Frequency",
    TYPE_OF_BUSINESS: "Type of Business",
    POLICY_TYPE: "Policy Type",
    PRIOR_POLICY : "Prior Policy",
    DESCRIPTION: "Description",
    INCEPTION_DATE: "Inception Date",
    AUDITABLE: "Auditable?",
    AGENCY_NEGOTIATED_COMMISSIONS: "Agency Negotiated Commissions",
    NONE : "None",
    PERCENT_OF_PREMIUM_FEES: "% of Premium/Fees",
    FLAT_RATE : "Flat Rate ($)",
    PERCENT : "Percent",
    AMOUNT : "Amount",
    TRANSACTION: "TRANSACTION",
    UPDATE_FROM_CUSTOMER : "Update from Customer",
    MAILING_ADDRESS_CUSTOMER_ADDRESS: "Mailing Address / Customer Address",
    RESIDENTIAL_ADDRESS :"Residential Address",
    POLICY_DETAIL_LOC: 'POLICY LOCATION',
    PROPERTY_ADDRESS: "PROPERTY ADDRESS",
    POLICY_TRANSACTION_PREM: 'POLICY TRANSACTION PREMIUM',
    ADD_CUSTOMER_COVERAGE: "Add Coverage",
    ADD_CUSTOMER_ENDORSEMENT: "Add Endorsement",
    INSURANCE_COMPANY: "Insurance Company",
    WRITING_COMPANY: "Writing Company",
    PARENT_COMPANY: "Parent Company",
    SOURCE:"Source",
    SOURCE_TYPE:"Source Type",
    APLUSNUMBER: "Advantage+ Number",
    PREVIOUS_ADDRESS: "Previous Address",
    FORM_NUMBER: "Form Number",
    FORM_TYPE: "Form Type",
    FLOOD_COVERAGE_BUILDINGLIMIT1:"Building Limit1 ($)",
    FLOOD_COVERAGE_BUILDINGPREMIUM:"Building Premium ($)",
    FLOOD_COVERAGE_CONTENTLIMIT1:"Content Limit1 ($)",
    FLOOD_COVERAGE_CONTENTPREMIUM:"Content Premium ($)",
    FLOOD_COVERAGE_ANNUALTOTAL:"Annual Total ($)",
    FLOOD_COVERAGE_DISCOUNTSURCHARGESTOTAL:"Discount Surcharges Total ($)",
    FLOOD_COVERAGE_ADDITIONALCOVERAGETOTAL:"Additional Coverage Total ($)",
    FLOOD_COVERAGE_PREPAIDTOTAL:"Prepaid Total ($)",
    FLOOD_COVERAGE_FLOODDEDUCTIBLE:"Flood Deductible ($)",
    FLOOD_COVERAGE_LABEL:"Flood Coverage",
    BASEMENT: 'Basement Type',
    PRIMARY_RESIDENT: 'Primary Resident',
    COURSE_OF_CONSTRUCTION: 'Course of Construction',
    OWNED_BY_STATE: 'Owned By State',
    REPLACE_COST: 'Replace Cost',
    CONDO_COVERAGE_FOR_UNIT: 'Condo Coverage For Unit',
    CONDO_NO_OF_UNITS: 'Condo No Of Units',
    HIGH_RISE: 'High Rise',
    BLDG_ELEVATED: 'Building Elevated',
    CONTENT_LOCATION_TYPE: 'Content Location Type',
    CONTENT_HOUSE_HOLD: 'Content House Hold',
    MOBILE_PARK_CONSTRUCTION_DATE: 'Mob Park Construt Date',
    CONSTRUCTION_DATE: 'Construction Date',
    IMPROVEMENT_DATE: 'Improvement Date',
    BLDG_DIAGRAM_NUM: 'Building Diagram Number',
    LOWEST_ADJ_GRADE: 'Lowest Adj Grade',
    LOWEST_FLOOR_ELEV: 'Lowest Floor Elev',
    BASE_FLOOR_ELEV: 'Base Floor Elev',
    BLDG_FLOOD_PROOF: 'Building Flood Proof',
    RATING_TYPE: 'Rating Type',
    DIAGRAM_NUMBER: 'Diagram Number',
    NEAREST_SHORE_TYPE: 'Nearest Shore Type',
    ELEVATION_FOUNDATION_TYPE: 'Elevation Foundation Type',
    ELEVATED_MATERIAL_TYPE: 'Elevated Material Type',
    ENCLOSED_FOR_OTHER_PURPOSE_TYPE: 'Enclosed For Other Purpose Type',
    ENCLOSED_FLOOR_TYPE: 'Enclosed Floor Type',
    NUMBER_OF_FLOORS: 'Number Of Floors',
    HAS_BASEMENT_EQUIP: 'Basement Equip',
    HAS_BASE_EQUIPMENT_FURNACE: 'Base Equipment Furnace',
    HAS_BASE_EQUIPMENT_WATER_HEATER: 'Base Equipment Water Heater',
    HAS_BASE_EQUIPMENT_ELEVATOR: 'Base Equipment Elevator',
    HAS_BASE_EQUIPMENT_HEAT_PUMP: 'Base Equipment Heat Pump',
    HAS_BASE_EQUIPMENT_FUEL_TANK: 'Base Equipment Fuel Tank',
    HAS_BASE_EQUIPMENT_WASHER_DRYER: 'Base Equipment Washer Dryer',
    HAS_BASE_EQUIPMENT_AIR_CONDITIONER: 'Base Equipment Air Conditioner',
    HAS_BASE_EQUIPMENT_CISTERN: 'Base Equipment Cistern',
    HAS_BASE_EQUIPMENT_FOOD_FREEZER: 'Base Equipment Food Freezer',
    HAS_BASE_EQUIPMENT_OTHER: 'Base Equipment Other',
    IS_GARAGE_ATTACHED: 'Garage Attached',
    HAS_GARAGE_EQUIPMENT_FURNACE: 'Garage Equipment Furnace',
    HAS_GARAGE_EQUIPMENT_WATER_HEATER: 'Garage Equipment Water Heater',
    HAS_GARAGE_EQUIPMENT_ELEVATOR: 'Garage Equipment Elevator',
    HAS_GARAGE_EQUIPMENT_HEAT_PUMP: 'Garage Equipment Heat Pump',
    HAS_GARAGE_EQUIPMENT_FUEL_TANK: 'Garage Equipment Fuel Tank',
    HAS_GARAGE_EQUIPMENT_WASHER_DRYER: 'Garage Equipment Washer Dryer',
    HAS_GARAGE_EQUIPMENT_AIR_CONDITIONER: 'Garage Equipment Air Conditioner',
    HAS_GARAGE_EQUIPMENT_CISTERN: 'Garage Equipment Cistern',
    HAS_GARAGE_EQUIPMENT_FOOD_FREEZER: 'Garage Equipment Food Freezer',
    HAS_GARAGE_EQUIPMENT_OTHER: 'Garage Equipment Other',
    HAS_ELEVATED_EQUIP: 'Elevated Equip',
    HAS_ELEVATED_EQUIPMENT_FURNACE: 'Elevated Equipment Furnace',
    HAS_ELEVATED_EQUIPMENT_WATER_HEATER: 'Elevated Equipment Water Heater',
    HAS_ELEVATED_EQUIPMENT_ELEVATOR: 'Elevated Equipment Elevator',
    HAS_ELEVATED_EQUIPMENT_HEAT_PUMP: 'Elevated Equipment Heat Pump',
    HAS_ELEVATED_EQUIPMENT_FUEL_TANK: 'Elevated Equipment Fuel Tank',
    HAS_ELEVATED_EQUIPMENT_WASHER_DRYER: 'Elevated Equipment Washer Dryer',
    HAS_ELEVATED_EQUIPMENT_AIR_CONDITIONER: 'Elevated Equipment Air Conditioner',
    HAS_ELEVATED_EQUIPMENT_CISTERN: 'Elevated Equipment Cistern',
    HAS_ELEVATED_EQUIPMENT_FOOD_FREEZER: 'Elevated Equipment Food Freezer',
    HAS_ELEVATED_EQUIPMENT_OTHER: 'Elevated Equipment Other',
    IS_ENCLOSED_FLOOR: 'Enclosed Floor',
    ENCLOSED_SIZE: 'Enclosed Size',
    IS_ELEVATED_MATERIAL: 'Elevated Material',
    IS_ENCLOSED_WITH_OPENING: 'Enclosed With Opening',
    IS_ENCLOSED_WITH_AREA_FINISHED: 'Enclosed With Area Finished',
    PROTECTION_DEVICE_TYPE: 'Protection Device Type',
    BURGLAR: 'Burglar',
    FIRE_PROTECTION: 'Fire',
    SMOKE: 'Smoke',
    TEMP: 'Temp',
    IMPROVED_PROT_CLASS: 'Improved Prot Class',
    RENOVATION_UPDATE: 'Renovation Update',
    WIRING_UPDATE: 'Wiring Update',
    WIRING_YEAR: 'Wiring Year',
    PLUMBING_UPDATE: 'Plumbing Update',
    PLUMBING_YEAR: 'Plumbing Year',
    HEATING_UPDATE: 'Heating Update',
    HEATING_YEAR: 'Heating Year',
    ROOFING_UPDATE: 'Roofing Update',
    ROOFING_YEAR: 'Roofing Year',
    EXTERIOR_PAINT_YEAR: 'Exterior Paint Year',
    DIVING_BOARD: 'Diving Board',
}

export const HOME = 'Home'
export const CUSTOMER = 'Customer'
export const CUSTOMERS = 'Customers'
export const CAMPAIGN = 'Campaign'
export const DOCUMATE = 'DocuMate+'
export const ADMIN = 'Admin'
export const MAINTENANCE = 'Maintenance'
export const CAMPAIGNS = 'Campaigns'
export const DASHBOARD = 'Dashboard'
export const ACCOUNTING = 'Accounting'
export const RETENTION = 'Retention'
export const FILTER = 'Filters'
export const CALENDAR = 'Calendar'
export const APPROVAL = 'Approval'
export const QUERIES = 'Queries'
export const EXTERNAL_TEMPLATE = '3rd Party Template'
export const CAMPAIGN_DETAILS = 'Campaign Details'
export const CAMPAIGN_APPROVAL = 'Campaign Approval'
export const CAMPAIGN_NAME = 'Campaign Name'
export const CAMPAIGN_DESCRIPTION = 'Campaign Description'
export const TEMPLATE_TYPE = 'Template Type'
export const TEMPLATE_NAME = 'Template Name'
export const TEMPLATE_DESCRIPTION = 'Template Description'
export const TEMPLATE_CATEGORY = 'Template Category'
export const QUERY_NAME = 'Query Name'
export const QUERY_DESCRIPTION = 'Query Description'
export const DATABASE_SERVER = 'Database Server'
export const FILTER_CRITERIA = 'Filter Criteria'
export const SEND_ON_DATE = 'Send on Date'
export const REQUESTED = 'Requested'
export const REQUESTED_BY = 'Requested By'
export const UPDATED_BY = 'Updated By'
export const LAST_UPDATED = 'Last Updated'
export const STATUS = 'Status'
export const APPROVED = 'APPROVED'
export const SAVE = 'Save'
export const DONTSAVE = `Don't Save`
export const EDIT = 'Edit'
export const SAVE_AS = 'Save As'
export const DELETE = 'Delete'
export const CANCEL = 'Cancel'
export const CLOSE = 'Close'
export const INACTIVE = 'Inactive'
export const RESULTS = 'Results'
export const TEST_QUERY = 'Test Query'
export const CAMPAIGN_SETTING = "Campaign Settings"
export const PLEASE_SELECT = "Please Select"
export const TEMPLATE_INACTIVE = "Template is inactive"
export const QUERY_INACTIVE = "Query is inactive"
export const SELECT_CONDITION = "Select Condition"
export const SELECT_VALUE = "Select Value"
export const CURRENCY = "currency"
export const NUMERIC = "numeric"
export const ZIP_CODE = "zip code"
export const CURRENCY_RANGE = "currency range"
export const NUMERIC_RANGE = "numeric range"
export const TO = "To"
export const AND = "And"
export const COLON = ":"
export const DELETE_CAMPAIGN = "Delete Campaign"
export const CAMPAIGN_DASHBOARD = "Campaign Dashboard"
export const CAMPAIGN_ID = "Campaign ID"
export const NAME = "Name"
export const CampaignType = "Type"
export const SEND_ON = "Send on"
export const CREATED_UPDATED = "Created/Updated"
export const Query = "Query"
export const CAMPAIGN_LIST = "Campaign List"
export const CAMPAIGN_WORKFLOWS = "Campaign Workflows"
export const CAMPAIGN_WORKFLOW_DETAIL = "Campaign Workflow Detail"
export const COMING_SOON = "Coming soon"
export const BACK_TO_CAMPAIGN_WORKFLOWS = "Back to Campaign Workflows"
export const NEW_CAMPAIGN = "New Campaign"
export const NEW_CAMPAIGN_WORKFLOW = "New Workflow"
export const CAMPAIGN_QUERIES = "Campaign Queries"
export const NEW_QUERY = "New Query"
export const QUERY_ID = "Query ID"
export const CREATED_ON = "Created on"
export const CREATED_BY = "Created By"
export const DESCRIPTION = "Description"
export const QUERY_DETAIL = "Query Detail"
export const QUERY_REQUIRED = "Query is required."
export const DATABASE_FIELD = "Database Field"
export const LOGIC = "Condition"
export const FRIENDLY_NAME = "Friendly Name"
export const FIELD_TYPE = "Field Type"
export const ADD_RULE = "ADD RULE"
export const DELETE_QUERY = "Delete Query"
export const NEW_EXTERNAL_TEMPLATE = "New 3rd Party Campaign"
export const TEMPLATE_ID = "Template ID"
export const CATEGORY = "Category"
export const SUMMARY = "Summary"
export const TEMPLATE_DETAILS = "Template Details"
export const CATEGORY_SUBCATEGORY = "Category/Sub Category"
export const CREATED_REQUESTED_BY = "Created/Requested By"
export const UPDATED_REQUESTED_BY = "Updated/Requested By"
export const CREATED = "Created"
export const INACTIVATE = "Inactivate"
export const ACTIVATE = "Activate"
export const CAMPAIGN_CALENDAR = "Campaign Calendar"
export const Search_CALENDAR = "Search by Campaign Name"
export const UNIQUE_KEY = "UNIQUE KEY"
export const UNIQUE = "UNIQUE"
export const YES = "Yes"
export const NO = "No"
export const EXPORT = "Export"
export const SHOW_FILTER = "Show Filter"
export const HIDE_FILTER = "Hide Filter"
export const UPDATED_ON = "Updated On"
export const SCROLL_TOP = "Go to Top"
export const CONFIRM = "Confirm"
export const DELETE_NOTE = "Delete Note"
export const UPDATED = "Updated"
export const NOTES = "Notes"
export const HISTORY = "History"
export const ADD_NEW_NOTE = "+ Add Note"
export const INCLUDE_INACTIVE_QUERIES = "Include inactive queries"
export const EXPORT_CSV = 'Export to csv'
export const INCLUDE_INACTIVE_CAMPAIGNS = "Include inactive campaigns"
export const INCLUDE_INACTIVE_CAMPAIGN_WORKFLOWS = "Include inactive workflows"
export const TRY_AGAIN = "Try again"
export const OVERIDE_SEND_ON_DATE = "Override Send On Date?"
export const INACTIVE_CAMPAIGN = "Inactive the campaign?"
export const CUSTOMER_NUMBER = "Customer Number"
export const POLICY_NUMBER = "Policy Number"
export const FIRST_NAME = "First Name"
export const LAST_NAME = "Last Name"
export const ADDRESS = "Address"
export const CITY = "City"
export const STATE = "State"
export const COUNTY = "County"
export const ZIP = "Zip"
export const AGENCY = "Agency"
export const SOURCE = "Source"
export const PHONE_NUMBER = "Phone Number"
export const EMAIL = "Email"
export const RATED_CARRIER = "Rated Carrier"
export const SEND_TEST = "SEND TEST"
export const Send_Test = "Send Test"
export const REQUEST = "REQUEST"
export const CONFIRM_CONTINUE = "Do you wish to continue?"
export const FORCED_CAMPAIGN_REQUEST = "Below campaigns are within 10 days within your campaign"
export const HAS_SEND_ON = "Has send on date of"
export const TOTAL = "Total"
export const FROM = "from"
export const RUN_QUERY = 'Run Query'
export const RECORD_COUNT = 'Record Count'
export const DELETE_TEMPLATE = "Delete Template"
export const SEND_TEST_EMAIL_LABEL = 'Send test to the Following emails'
export const SEND_TEST_EMAIL_PLACEHOLDER = 'Enter email(s) separated by ;'
export const SEND = 'SEND'
export const APPROVAL_INFORMATION = 'Approval Information'
export const APPROVED_BY = 'Approved By'
export const APPROVAL_DATE = 'Approval Date'
export const REJECT = 'REJECT'
export const APPROVE = 'APPROVE'
export const REJECT_REASON = 'Rejection Reason'
export const REJECT_REASON_PLACEHOLDER = 'Enter a Rejection Reason'
export const CAMPAIGNSENTDATE = 'Campaigns Sent'
export const CAMPAIGN_FROM_EMAIL_PLACEHOLDER = "Please select 'from' email"
export const FROM_EMAIL = 'From Email'
export const EmployeeId = 'EmployeeID'
export const LastLogin = 'Last Login'
export const UserSetupCompleted = 'User Setup'
export const EMPLOYEE_SETUP = 'Employee Setup'
export const NEW_USER = 'New User'
export const NEW_EMPLOYEE = "New User"
export const USER_SEARCH_FILTER = "User Search Filter"
export const USER_SEARCH_DETAILS = "User Search Details"
export const USER_SETUP = "User Setup"
export const HISTORY_TAB = "History"
export const EDIT_POLICY = 'Edit Policy'
export const POLICY_DETAILS = 'Policy Details'
export const POLICY_FILE = 'Assignments'
export const UPLOAD = 'Upload'
export const REFRESH = 'Refresh'
export const MEMO_HISTORY = 'Memo History'
export const NO_DATA = 'No Data to Display'
export const ADD_NEW_WRITING = 'Add New'
export const DEFAULT_DOCUMATE_GROUP_DDL = "Default Documate Group"
export const MODIFIED_USER = "Modified User"
export const MODIFIED_EMPLOYEE = "Modified Employee"
export const EXPORT_ALL_USERS_HISTORY = "Export All User History"
export const EXPORT_ALL_EMPS_HISTORY = "Export All Employee History"
export const UNKNOWN = "Unknown"

export const UnmatchedPolicy = {
    TRANSACTION_TYPE: "Transaction Type",
    SHOW_ON_HOLD: " Show on hold",
    POLICY_TRANSACTION: "Policy Transaction",
    ADDRESS: "Address",
    TRANSACTION: "Transaction",
    ENTRY_DATE : "CS2 Entry Date",
    RECEIVED_DATE: "Received Date",
    CARRIER_TRANSACTION_DATE: "Carrier Transaction Date",
    EFFECTIVE_DATE: "Effective Date",
    PREMIUM: "Premium",
    COMPANY_CODE: "Company Code",
    MGA_CODE: "MGA Code",
    AGENCY_CODE: "Agency Code",
    AGENT_NAME_CODE: "Agent Name/Code",
    AGENCY_CODE_STATUS: "Agency/Status",
    PRODUCER_SUB_CODE: "Producer Sub Code",
    NAME_POLICY: "Name/Policy #",
    SUB_AGENCY: "Sub Agency",
    Term: "Term",
    ADDRESS_COVERAGE: "Address/Coverage",
    CITY: "City",
    STATE: "State",
    ZIP: "Zip",
    APPLY: "Apply",
    CREATE_CUSTOMER: "Create Customer",
    QUICK_SEARCH: "Quick Search",
    ADDITIONAL_POLICY: "Additional Policy Information",
    PROPERTY_ADDRESS: "Property Address",
    SOURCE: "Source",
    TERM: "Term",
    STATUS: "Status",
    PRODUCER: "Producer",
    DESCRIPTION: "Description",
    PALACEONHOLD:"Place on Hold",
    REMOVEHOLD: "Remove Hold",
    CREATECUSTOMERANDAPPLY: "Create Customer and Apply",
    DELETE: "Delete",
    MODIFY: "Modify",
    CANCEL: "Cancel",
    CS2CUSTOMER: "CS2 Customer",
    ATMSCUSTOMER: "ATMS Customer",
    COPYTIOCS2ANDAPPLY: "Copy To CS2 and Apply",
    EXPIRY_DATE: "Expiration Date",
    LINE_OF_BUSINESS: "Line of Business",
    SHOW_ERROR: "Show Error",
    SHOW_REASON: "Show Reason",
    POLICY_TRANSACTION_APPLY_MISMATCH:"Policy term is different, do you want to apply?",
    POLICY_TRANSACTION_APPLY_NOT_LATEST:"Policy term not latest, do you want to apply?",
    POLICY_TRANSACTION_APPLY_POLICY_NUMBER_MISMATCH:"Policy number does not match. Do you wish to continue?",
    SAVE: "Save",
    POLICY_TRANSACTION_DELETE : "Are sure you want to delete the policy transaction?",
    POLICY_TRANSACTION_DELETE_ERROR : "Unable to delete policy transaction.",
    TRANSACTION_EFECTIVE_DATE : "Transaction Effective date",
    SEARCH:"Search",
    EMAIL : "Email Address",
    PARENT_COMPANY:"Parent Company"
}

export const PolicyActionLabels = {
    POLICY_NUMBER: "Policy Number",
    EFFECTIVE_DATE: "Effective Date",
    EXPIRATION_DATE: "Expiration Date",
    LINE_OF_BUSINESS: "Line Of Business",
    FORM_TYPE: "Form Type",
    BUSINESS_TYPE: "Type Of Business",
    TRANSACTION_TYPE: "Transaction",
    ISSUE_STATE: "Issue State",
    LOCATION: "Location",
    SOURCE: "Source",
    SOURCEID: "Source ID",
    AGENCY:"Agency",
    DESCRIPTION:"Description",
    CANCELLATION_LABEL:"TO CANCEL THIS POLICY, ENTER THE BASIC CANCELLATION INFORMATION AND PRESS SUBMIT",
    ENDORSE_LABEL:"TO CREATE THIS TRANSACTION, ENTER THE INFORMATION BELOW AND PRESS SUBMIT",
    CANCELLATION_SUBMIT_MESSAGE:"Cancellation has been submitted.",
    ENDORSEMENT_SUBMIT_MESSAGE:"Endorsement has been submitted.",
    ERROR_MESSAGE:"Failed to submit. Please try again later.",
    CANCELLATION_REASON_LABEL:"Cancellation Reason",
    CANCELLATION_POPUP_HEADER: "Confirmation",
    ADD_NEW_POLICY: "ADD NEW POLICY",
    INSURANCE_COMPANY: "Insurance Company",
    PARENT_COMPANY: "Parent Company",
    DELETE_POLICY_CONFIRM_MESSAGE:"Are you sure you want to delete this policy? This action cannot be undone.",
    DELETE_POLICY_SUCCESS_MESSAGE: "Policy has been deleted.",
    DELETE_POLICY_PENDING_TASKS_MESSAGE: "Policy cannot be deleted. Pending tasks exist for this policy.",
    FULL_TERM_PREMIUM:"Full Term Premium ($)",
    PREMIUM:"Premium ($)",
}

export const Statistics = {
    STATISTICS_HEADER: "Statistics for Policy Assignment",
    FROM_DATE: "From Date",
    TO_DATE: "To Date",
    USER: "Users",
    GET_RESULTS: "Get Results",
    Carriers: "Carriers",
    Total_Transaction_Count: "Total Transaction Count",
    Total_Applied_Automatically_Count: "Total Applied Automatically Count",
    Remaining_Count: "Remaining Count",
    Total_Premium: "Total Premium",
    Average_Premium: "Average Premium",
    Total_Error: "Total Error",
    Total_Hold: "Total Hold",
    USER_STATISTICS_HEADER: "Statistics for Users (ET)",
    As_Per_Dates: "As Per Dates",
    User_Total: "User Total"
}

export const LookUpTableLabels = {
    LOOKUP_VALUE: "Look Up Value",
    LOOKUP_CODE: "Look Up Code",
    IN_ACTIVE: "Inactive",
    PLACEHOLDER_LOOKUPVALUE: "Enter Lookup Value",
    PLACEHOLDER_LOOKUPCODE: "Enter Lookup Code"

}

export const RecurringCampaignLabels = {
    RECURRING_SCHEDULE: "Recurring Schedule",
    RUN_FREQUENCY: "Frequency",
    STARTS: "Starts",
    ENDS: "Ends",
    NEVER: "Never",
    ON: "On",
    START_DATE: "Start Date",
    END_DATE: "End Date",
    SELECT_DATE: "Select Date"
}

export const CommissionStatementLabels = {
  PAGE_TITLE: 'Commission Statement',
  STEP_UPLOAD: 'Upload',
  STEP_PREVIEW: 'Preview',
  STEP_CONVERT: 'Convert',
  STEP_MIGRATE: 'Migrate',
  STEP1_TITLE: 'Step 1: Select Carrier, Month & Upload File',
  STEP2_TITLE: 'Step 2: Preview Imported Data',
  STEP3_TITLE: 'Step 3: Error Details', 
  STEP4_TITLE: 'Step 4: Migration Details', 
  INFO_BOX1: 'Select the carrier company and statement month, then upload the Excel file. The file will be imported into the corresponding staging table for review.',
  INFO_BOX2: 'Below is a preview of the data imported. Review the data carefully before moving to the next step.',
  INFO_BOX3: 'Below is a preview of the data imported. Review the data carefully before moving to the next step.',
  INFO_BOX3_ERROR: 'Error(s) found in the imported data. These must be resolved (correct the source file and re-import) before you can migrate.',
  INFO_BOX4: 'Migration complete. The records have been processed and saved to CarrierManagement.CommissionStatement.',
  INFO_BOX4_ERROR: 'Migration failed. Records could not be processed. Please review the error and upload the file again.',
  CARRIER_COMPANY_LABEL: 'Carrier Company',
  STATEMENT_MONTH_LABEL: 'Statement Month',
  FILE_UPLOAD_TEXT: 'Click to select a Excel file',
  NO_FILE_MESSAGE: 'No File Selected',
  CONVERT_MESSAGE: 'File is ready to migrate',
  IMPORT: 'Import',
  CANCEL: 'Cancel',
  TOTAL_ROWS: 'TOTAL ROWS',
  TOTAL_COLUMNS: 'COLUMNS',
  NULL_POLICY: 'NULL POLICY COUNT',
  ERROR_COUNT: 'ERROR COUNT',
  MIGRATED_COUNT: 'RECORDS MIGRATED',
  SKIPPED_COUNT: 'SKIPPED',
  CONVERT: 'Convert',
  MIGRATE: 'Migrate',
  REIMPORT: 'Import Another File'
}

export const MortgageLabels = {
    MORTGAGE_COMPANY: 'Mortgage Company',
    COMPANY_NAME: 'Company Name',
    NAME: 'Name',
    TYPE: 'Type',
    PHONE: 'Phone',
    CITY: 'City',
    STATE: 'State',
    CITY_STATE: 'City, State',
    ACTIVE: 'Active',
    STATUS: 'Status',
    LAST_MODIFIED: 'Last Modified',
    ACTION: 'Action',
    PLEASE_SELECT: 'Please Select',
    SAVE: 'Save',
    CANCEL: 'Cancel',
}

export const AgencyMasterCodesLabels = {
    ACTIONS: 'Actions',
    AGENCY: 'Agency',
    LINE_OF_BUSINESS: 'Line of Business',
    AGENCY_CODE: 'Agency Code',
    MARKET_TYPE: 'Market Type',
    EFFECTIVE_DATE: 'Effective Date',
    PROPERTY_STATE: 'Property State',
    NOTE: 'Note',
    BTN_EDIT: 'Edit',
    BTN_DELETE: 'Delete',
    NO_RECORDS_FOUND: 'No agency codes found.',
}

export const CarrierManagementLabels = {
    CONTACT_INFORMATION_TITLE: 'Contact Information',
    AGENCY_MASTER_CODES_TITLE: 'Agency Master Codes',
    ADD_ROW_LABEL: 'Add Row',
}

export const CompensationRateLabels = {
    ACTIONS: 'Actions',
    AGENCY: 'Agency',
    CARRIER: 'Carrier',
    STATE: 'State',
    POLICY_TYPE: 'Policy Type',
    LINE_OF_BUSINESS: 'Line of Business',
    TRANSACTION_TYPE: 'Transaction Type',
    EFFECTIVE_DATE: 'Effective Date',
    RATE: 'Rate',
    NOTES: 'Notes',
    BTN_EDIT: 'Edit',
    BTN_DELETE: 'Delete',
    BTN_DUPLICATE: 'Duplicate row',
    ADD_ROW_LABEL: 'Add Row',
}